import * as React from "react";
import {
    DateInput,
    Edit,
    Link,
    minValue,
    NumberInput,
    required,
    SaveButton,
    SelectInput,
    SimpleForm,
} from "react-admin";

const warningWithinMaximum = (value, values) =>
    value && values.maxDownloads && value > values.maxDownloads
        ? 'Warning at must not be greater than maximum downloads'
        : undefined;

export const DownloadSettingsEdit = () => {
    const Save = () => {
        return (
            <div className="customerActionToolbar edit-user-btns">
                <Link to={`/downloads/settings/custom/show`} className="button bar-purple-button">Cancel</Link>
                <SaveButton alwaysEnable label="Save" className="button bar-gradient-button" icon={<></>}/>
            </div>
        );
    }

    return <div className="edit-customer">
        <h2 className="dailyTitle">Downloads</h2>
        <Edit mutationMode="pessimistic" redirect={'show'}>
            <SimpleForm toolbar={<Save/>}>
                <SelectInput
                    helperText={'Switch the download limit on or off'}
                    label="Limit enabled:" name="enabled" source="enabled" fullWidth id="enabled"
                    validate={required()} defaultValue={1}
                    choices={[
                        {id: 1, name: "On"},
                        {id: 0, name: "Off"}
                    ]}/>
                <NumberInput
                    helperText={'The download limit'}
                    label="Maximum downloads:" name="maxDownloads" source="maxDownloads" id="maxDownloads"
                    fullWidth defaultValue={100} validate={[required(), minValue(1)]}/>
                <NumberInput
                    helperText={'When the "approaching the limit" message appears'}
                    label="Warning at:" name="warningAt" source="warningAt" id="warningAt"
                    fullWidth defaultValue={90} validate={[required(), minValue(1), warningWithinMaximum]}/>
                <DateInput
                    helperText={'When the limit starts applying. Shown in the grace period warning. Leave empty while the release date is not known'}
                    label="Enforcement date:" name="enforcementDate" source="enforcementDate" id="enforcementDate"
                    fullWidth/>
            </SimpleForm>
        </Edit>
    </div>
}
